module.exports = __webpack_public_path__ + "img/form.ac89475e.png";